import { useNavigate } from 'react-router-dom';

export default function GuideSection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="w-full max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <p className="font-label text-xs text-primary-600 tracking-[0.2em] uppercase mb-3">
            Shopping Resources
          </p>
          <h2 className="section-title mb-3">Expert Shopping Guides</h2>
          <p className="section-subtitle mx-auto">
            In-depth articles and resources to help you become a smarter, more efficient shopper.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="card-base p-6 md:p-8 group hover:border-foreground-200">
            <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-5">
              <i className="ri-book-open-line text-xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              The Ultimate Guide to SuperBuy Spreadsheet
            </h3>
            <p className="font-body text-sm text-foreground-500 leading-relaxed mb-5">
              Everything you need to know about using SuperBuy Spreadsheet for product research,
              from beginner basics to advanced strategies for finding the best deals.
            </p>
            <button
              onClick={() => navigate('/guide/superbuy-spreadsheet-guide')}
              className="inline-flex items-center gap-2 font-label text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
            >
              Read Full Guide
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="card-base p-6 md:p-8 group hover:border-foreground-200">
            <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-5">
              <i className="ri-user-star-line text-xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              Beginner&apos;s Handbook
            </h3>
            <p className="font-body text-sm text-foreground-500 leading-relaxed mb-5">
              New to spreadsheet shopping? This step-by-step guide walks you through every basic
              concept so you can start discovering products with confidence from day one.
            </p>
            <button
              onClick={() => navigate('/guide/superbuy-spreadsheet-beginners')}
              className="inline-flex items-center gap-2 font-label text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
            >
              Start Learning
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="card-base p-6 md:p-8 group hover:border-foreground-200">
            <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-5">
              <i className="ri-footprint-line text-xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              Sneaker Shopping Guide
            </h3>
            <p className="font-body text-sm text-foreground-500 leading-relaxed mb-5">
              Dive deep into the most popular category. Learn proven techniques for comparing
              sneakers, understanding sizing, and building a versatile collection.
            </p>
            <button
              onClick={() => navigate('/guide/superbuy-spreadsheet-sneakers')}
              className="inline-flex items-center gap-2 font-label text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
            >
              Explore Sneakers
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="card-base p-6 md:p-8 group hover:border-foreground-200">
            <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mb-5">
              <i className="ri-shield-check-line text-xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
              Safety &amp; Smart Shopping
            </h3>
            <p className="font-body text-sm text-foreground-500 leading-relaxed mb-5">
              Essential safety practices every online shopper should know. From verifying sellers
              to protecting your payment info — shop smarter and stay protected.
            </p>
            <button
              onClick={() => navigate('/guide/superbuy-spreadsheet-safety')}
              className="inline-flex items-center gap-2 font-label text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
            >
              Read Safety Guide
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}